import React, {useEffect, useState} from 'react';
import ScoreView from './ScoreView';
import QuestionFactor from "./question/QuestionFactor";
import testService from "../../../services/test.service";
import lessonService from "../../../services/lesson.service";
import theme from "../../../theme";
import 'katex/dist/katex.min.css';
import deleteDraftAnswer from "../../../helpers/deleteDraftAnswer";
import "./styles/TestProgressView.css";
import TitleAlert from "./TitleAlert";
import SendIcon from '@material-ui/icons/Send';
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {
    isOnlineState,
    isTouchAudioState,
    isTouchVideoState,
    isZoomingImage,
    requiredTimeSubmitState,
    timeOutState,
    timeOutV2State,
    valueSlideState
} from "../../../states/states";
import {
    answersState,
    currentQuestionIndexState,
    currentQuestionState,
    currentTestState,
    lessonTypeState,
    nextAbleQuestionsState,
    numberOfQuestionState,
    testTypeState
} from "../../../states/test_progress_states";
import CustomSweetAlert from "../../helper/CustomSweetAlert";
import getErrorMessage from "../../../config/ErrorMessage";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import withErrorMessage from "../../HOC/withErrorMessage";
import withUrlParams from "../../HOC/withUrlParams";
import {Swipeable} from 'react-swipeable';
import {lessonTypes, testTypes} from './../../../config/constants';
import i18n from 'i18next';
import logService from "../../../services/log.service";


const TestProgressPage = props => {
    const {testCode, lessonCode, accessToken, answersStorageKey} = props;
    const currentTestData = useRecoilValue(currentTestState);
    const [numberOfQuestions, setNumberOfQuestions] = useRecoilState(numberOfQuestionState);
    const [answers, setAnswers] = useRecoilState(answersState);
    const [testResult, setTestResult] = useState({});
    const [showSweetAlert, setShowSweetAlert] = useState(false);
    const [errorCode, setErrorCode] = useState("");
    const [timeOut, setTimeOut] = useRecoilState(timeOutState);
    const nextAbleQuestions = useRecoilValue(nextAbleQuestionsState);
    const [nextAble, setNextAble] = useState(false);
    const setTimeOutV2 = useSetRecoilState(timeOutV2State);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useRecoilState(currentQuestionIndexState);
    const [currentQuestion, setCurrentQuestion] = useRecoilState(currentQuestionState);
    const requiredTimeSubmit = useRecoilValue(requiredTimeSubmitState);
    const testType = useRecoilValue(testTypeState);
    const lessonType = useRecoilValue(lessonTypeState);
    const keyCountdownLsg = `timeCountdown${testCode ? `test${testCode}` : `lesson${lessonCode}`}`;
    const zoomedImage = useRecoilValue(isZoomingImage);
    const [valueSlide, setValueSlide] = useRecoilState(valueSlideState);
    const isOnline = useRecoilValue(isOnlineState);
    const [isTouchVideo, setIsTouchVideo] = useRecoilState(isTouchVideoState);
    const [isTouchAudio, setIsTouchAudio] = useRecoilState(isTouchAudioState);
    const isLastPage = currentQuestionIndex === currentTestData.questions.length;
    const isScorePage = currentQuestionIndex === numberOfQuestions + 1;

    useEffect(() => {
        localStorage.setItem(keyCountdownLsg, 1);
    }, []);

    useEffect(() => {
        if (currentQuestionIndex <= currentTestData.questions.length) {
            setCurrentQuestion(currentTestData.questions[currentQuestionIndex - 1]);
        }
        window.scrollTo(0, 0);
    }, [currentQuestionIndex]);

    useEffect(() => {
        if (numberOfQuestions !== currentTestData.questions.length) {
            setNumberOfQuestions(currentTestData.questions.length)
        }
    }, []);

    useEffect(() => {
        setNextAble(currentQuestion && nextAbleQuestions && nextAbleQuestions.includes(currentQuestion.questionCode));
    });

    //submit and move to the score page when timeout
    useEffect(() => {
        if (timeOut === true) {
            setTimeOutV2(true);
            handleWhenSubmit();
        }
        if (lessonCode && lessonType === 2) {
            if (document.getElementsByClassName('buttonProgress')[0]) {
                document.getElementsByClassName('buttonProgress')[0].classList.add("addButtonProgress");
            }
            if (document.getElementsByClassName('buttonNext')[0]) {
                document.getElementsByClassName('buttonNext')[0].classList.add("addButtonNext");
            }
            if (document.getElementsByClassName('buttonPrevious')[0]) {
                document.getElementsByClassName('buttonPrevious')[0].classList.add("addButtonPrevious");
            }
        }
    });

    const submitQuiz = () => {
        if (isOnline) {
            setShowSweetAlert(true);
        }
    };

    const handleWhenSubmit = () => {
        if (currentTestData.testCode && isOnline) {
            testService.submitTest(currentTestData.testCode, answers.filter(answer => answer.isSelected === true), accessToken)
                .then(
                    response => {
                        setTimeOut(false);
                        if (response.data) {
                            logService.log("info", "handleWhenSubmit", `testCode: ${currentTestData.testCode}; token: ${accessToken}; `, JSON.stringify(response.data));
                            setTestResult(response.data);
                            setCurrentQuestionIndex(numberOfQuestions + 1); // Move to the score page
                            clearDataOnsubmit();
                        } else {
                            logService.log("error", "handleWhenSubmit", `testCode: ${currentTestData.testCode}; token: ${accessToken}; `, JSON.stringify(response));
                        }
                    })
                .catch((error) => {
                    setTimeOut(false);
                    logService.log("error", "handleWhenSubmit", `testCode: ${currentTestData.testCode}; token: ${accessToken}; `, '');
                });
        } else if (currentTestData.lessonCode && isOnline) {
            lessonService.submitLesson(currentTestData.lessonCode, answers.filter(answer => answer.isSelected === true), accessToken)
                .then(
                    response => {
                        setTimeOut(false);
                        if (response.data) {
                            logService.log("info", "handleWhenSubmit", `lessonCode: ${currentTestData.testCode}; token: ${accessToken}; `, JSON.stringify(response.data));
                            setTestResult(response.data);
                            setCurrentQuestionIndex(numberOfQuestions + 1); // Move to the score page
                            clearDataOnsubmit();
                        } else {
                            logService.log("error", "handleWhenSubmit", `lessonCode: ${currentTestData.testCode}; token: ${accessToken}; `, JSON.stringify(response));
                        }
                    })
                .catch((error) => {
                    setTimeOut(false);
                    logService.log("error", "handleWhenSubmit", `lessonCode: ${currentTestData.testCode}; token: ${accessToken}; `, "");
                });
        }
    };

    const clearDataOnsubmit = () => {
        localStorage.removeItem(keyCountdownLsg);
        deleteDraftAnswer(currentTestData.questions); //delete draft answer in localStorage
        localStorage.removeItem(answersStorageKey);
        setAnswers([]);
    };

    const handleNextPage = () => {
        if (currentQuestionIndex < numberOfQuestions && nextAble) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        }
        if (valueSlide < numberOfQuestions && nextAble) {
            setValueSlide(valueSlide + 1);
        }
    };

    const handlePreviousPage = () => {
        if (testType === testTypes.THI_CU) {
            if (currentQuestionIndex > 1) {
                setCurrentQuestionIndex(currentQuestionIndex - 1);
            }
        }
        if (lessonType === lessonTypes.KT_CUOI_KY || lessonType === lessonTypes.ON_TAP) {
            if (currentQuestionIndex > 1) {
                setCurrentQuestionIndex(currentQuestionIndex - 1);
            }
        }
        if (valueSlide > 1) {
            setValueSlide(valueSlide - 1);
        }
    };

    const swipeableNextPage = () => {
        if (isTouchVideo) {
            setIsTouchVideo(false);
            return;
        }
        if (isTouchAudio) {
            setIsTouchAudio(false);
            return;
        }
        handleNextPage()
    };

    const swipeablePrevPage = () => {
        if (isTouchVideo) {
            setIsTouchVideo(false);
            return;
        }
        if (isTouchAudio) {
            setIsTouchAudio(false);
            return;
        }
        handlePreviousPage()
    };

    const nextPage = () => {
        handleNextPage()
    };

    const previousPage = () => {
        if (currentQuestionIndex === 1) {
            window.location.reload();
        } else {
            handlePreviousPage();
        }
    };

    useEffect(() => {
        const underlineCurrentQuestionIndex = () => {
            for (let i = 0; i < numberOfQuestions; i++) {
                if (document.getElementById(`slide${i}`)) {
                    if (i === currentQuestionIndex - 1) {
                        document.getElementById(`slide${i}`).parentElement.style.borderBottom = "3px solid #ae9ff5";
                    } else {
                        document.getElementById(`slide${i}`).parentElement.style.borderBottom = "none";
                    }
                }
            }
        };
        underlineCurrentQuestionIndex();
    }, [currentQuestionIndex]);

    // Swipable config
    const swipableConfig = {
        onSwipedLeft: () => swipeableNextPage(),
        onSwipedRight: () => swipeablePrevPage(),
        preventDefaultTouchmoveEvent: true,   // preventDefault on touchmove, *See Details*
        trackMouse: !zoomedImage,                     // track mouse input
        trackTouch: !zoomedImage
    };

    // Render the current page
    const renderPage = () => {
        if (errorCode) {
            return <CustomSweetAlert showConfirm={false} text={getErrorMessage(errorCode)}/>;
        }
        if (isScorePage) {
            return <ScoreView testResult={testResult}/>
        }

        if (currentQuestion) {
            return (
                <Swipeable {...swipableConfig}>
                    <React.Fragment>
                        {<CustomSweetAlert show={isOnline && timeOut} text={i18n.t('SUBMITTING')} showConfirm={false}/>}
                        {<CustomSweetAlert show={!isOnline && timeOut} text={i18n.t('NO_NETWORK')}
                                           showConfirm={false}/>}
                        <div key={currentQuestion.questionCode} className={"QuestionFactor"}
                             style={{padding: theme.rootPadding}}>
                            <QuestionFactor
                                question={currentQuestion}
                                index={currentQuestionIndex}
                            />
                            <div className="buttonProgress">
                                <div className={"buttonNext"}>
                                    {<button type="button" className="btn btn-next-custom"
                                             onClick={isLastPage ? submitQuiz : nextPage}
                                             disabled={!nextAble || (isLastPage && !requiredTimeSubmit)}
                                    >
                                        {isLastPage ?
                                            <span className="submit">{i18n.t('submit').toUpperCase()}
                                                <SendIcon/></span> :
                                            <span className="ios-icon">{i18n.t('continue').toUpperCase()}
                                                <ArrowForwardIosIcon/></span>}
                                    </button>}
                                </div>
                                {
                                    lessonCode && lessonType === 2
                                        ? <div className={"buttonPrevious"}>
                                            <button type="button" className="btn btn-next-custom"
                                                    onClick={previousPage}><span
                                                className="ios-icon"><ArrowBackIosIcon/> {i18n.t('comeback').toUpperCase()}</span>
                                            </button>
                                        </div> : <></>
                                }
                            </div>
                            <div className={"confirmAlert"}>
                                <CustomSweetAlert
                                    show={showSweetAlert}
                                    title={TitleAlert(testType)}
                                    titleSize={"12px"}
                                    showCancel={true}
                                    confirmBtnText={i18n.t('yes')}
                                    cancelBtnText={i18n.t('no')}
                                    onConfirm={() => {
                                        setShowSweetAlert(false);
                                        handleWhenSubmit();
                                    }}
                                    onCancel={() => {
                                        setShowSweetAlert(false);
                                    }}
                                />
                            </div>
                        </div>
                    </React.Fragment>
                </Swipeable>


            );
        }
        // No selected question, return nothing.
        else return '';
    };

    return (
        renderPage()
    );
};

export default withUrlParams(withErrorMessage(TestProgressPage));
